import { IAisRootConfig } from './aisRootConfig/IAisRootConfig'
import { IIrisConfigContainerConstParam, IrisConfigContainer } from './IrisConfigContainer'
import { IIrisModContainerConstParam, IrisModContainer } from './IrisModContainer'

/**
 * Conteneur de la réponse `GET /api/iris/aisrootconfig/0`.
 *
 * Contrairement à IrisrawModAis (config AIS par mission), on ne fait AUCUN
 * deepmerge avec des valeurs par défaut : la config racine a une forme propre
 * (Main + AIS.nb_request) et on veut refléter strictement ce qu'IRIS renvoie.
 */
export class IrisrawModAisRoot extends IrisModContainer<IrisConfigContainer<IAisRootConfig>> {
  constructor({ ...args }: IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
    super(args, IrisrawModAisRoot.createIrisAisRootConfig)
  }

  static createIrisrawModAisRoot(datas: IIrisModContainerConstParam) {
    return new IrisrawModAisRoot(datas)
  }

  static createIrisAisRootConfig(data: IIrisConfigContainerConstParam) {
    return new IrisConfigContainer<IAisRootConfig>(data ?? { mod_settings: {} })
  }
}
